import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="flex-center" style={{ minHeight: '100vh', flexDirection: 'column', gap: '2rem' }}>
    <h1 style={{ fontSize: '8rem', fontWeight: '900', background: 'linear-gradient(135deg, var(--primary), var(--accent))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>404</h1>
    <h2>Page Not Found</h2>
    <p style={{ color: 'var(--text-secondary)' }}>The page you're looking for doesn't exist.</p>
    <Link to="/" className="btn btn-primary">Go Home</Link>
  </div>
);

export default NotFound;
